import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { breakpoint } from './utilities/breakpoint-setup'

gsap.registerPlugin(ScrollTrigger);

  // Videos page

  let loading = 0;
  $('.js-videos-more').click(function(){
    let s = $(this).attr('search')
    let offset = $(this).attr('offset')
    let per_page = $(this).attr('per-page')
    let $button = $(this)
    let loader = $button.parent().find('.loader')

    if (loading === 0) {
      $button.css('opacity', 0)
      loader.css('display', 'inline-block')

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: 'action=loadmore&s=' + s + '&offset=' + offset + '&per-page=' + per_page,
        success: function (results) {
          loader.css('display', 'none');
          if (results.ismore == 1) {
            $button.css('opacity', 1);
          }

          let $videos = $(results.newposts)
          $('.js-videos').append($videos)
          $videos.addClass('visible');
          $videos.addClass('animated');
          $videos.addClass('fadeInUp');

          $button.attr('offset', parseInt(offset) + parseInt(per_page) - 1);

        }
      })

    }

  })


  // menu js
  $('.js-resp-menu-toggle, .menu-el a').click(function(){

    if(breakpoint('screen') < breakpoint('lg')) {
      let burger = $(this).find('.burger')
      if (burger.hasClass('active')){
        $('.js-close-text').css('display', 'none')
        $('.js-open-text').fadeIn(200)
      } else {
        $('.js-open-text').css('display', 'none')
        $('.js-close-text').fadeIn(200)
      }
      burger.toggleClass('active')
      $('.menu-c').fadeToggle()
    }

  })


